import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { config } from 'app/constants';
import { DataService } from 'app/services/data.service';
import { AppTemplateDirective } from 'app/directive/template.directive';

import * as $ from 'jquery';
import { Subscription } from 'rxjs';
import { AllowDecimalMask } from 'app/services/sharedInterfaces';
import { HelperService } from 'app/services';

@Component({
  selector: 'app-dropdown',
  templateUrl: './app-dropdown.component.html',
  styleUrls: ['./app-dropdown.component.scss'],
})
export class AppDropdownComponent implements OnInit, AfterContentInit, OnChanges, OnDestroy {
  @Input() name: string = '';
  @Input() placeholder: string = '';
  @Input() id: string = '';
  @Input() listId: string = '';
  @Input() value: any = '';
  @Input() editFieldMask: any = '';
  @Input() field: string = 'name';
  @Input() options: any[];
  @Input() closeOnSelection: boolean = true;
  @Input() editFieldLabel: string = 'Create New';
  @Input() editFieldMaxLength: number = 50;
  @Input() minCreateStrLength: number = 3;
  @Input() createButtonTitle: string = 'Save';
  @Input() showSelectedValue: boolean = true;
  @Input() autoFocus: boolean = false;
  @Input() isDropdownIconVisible: boolean = false;
  @Input() leftIcon: string;
  @Input() isInline: boolean = false;
  @Input() showIconToOpen: boolean = false;
  @Input() openDropdownIcon: string = 'fal fa-ellipsis-h';
  @Input() fontSize: number = 12;
  @Input() scrollHeight: string = '100px';
  @Input() listHeaderTitle: string = '';
  @Input() itemWidth: string = '';
  @Input() itemMargin: string = '';
  @Input() isShowError: boolean = false;
  @Input() theme: string = 'primary'; // [light, primary, secondary, border]
  @Input() position: string = 'bottom'; // [bottom, top]
  @Input() hPosition: string = 'right'; // [left, right]
  @Input() idKey: string = 'value';
  @Input() styleClass: string = '';
  @Input() styleClassSelectedView: string = '';
  @Input() styleClassDropdownList: string = '';
  @Input() styleClassDropdownListItem: string = '';
  @Input() styleClassValue: string = '';
  @Input() styleClassLabel: string = '';
  @Input() styleClassText: string = '';
  @Input() styleClassError: string = '';
  @Input() styleClassPlaceholder: string = '';
  @Input() label: string = '';
  @Input() rightIcon: string = '';
  @Input() errorMessage: string = '';
  @Input() listItemFontSize: number = this.fontSize;
  @Input() disabled: boolean = false;
  @Input() prohibited: boolean = false;
  @Input() fullyControlled: boolean = false;
  @Input() focusOnSelectedValue: boolean = false;
  @Input() truncateString: boolean = false;
  @Input() floatingLabel: boolean = false;
  @Input() hasHoverEffect: boolean = false;
  @Input() hasBorderBottomOnActive: boolean = true;
  @Input() hasHoverBorderBottom: boolean = true;
  @Input() isActive: boolean = true;
  @Input() hasBgOnActive: boolean = false;
  @Input() parentContainer: ElementRef;
  @Input() selectInactiveItems: boolean = true;
  @Input() inactiveItemsKey: string = '';
  @Input() hasFooter: boolean = false;
  @Input() isStaticEditButton: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() isFromTable: boolean = false;


  @Input() hasEditableField: boolean = false;
  @Input() hasEditableFieldIndication: boolean = false;
  @Input() hasStaticUnassignedFiled: boolean = false;
  @Input() hasColorSelection: boolean = false;
  @Input() hasCustomItemTemplate: boolean = false;
  @Input() hasCustomOpenTemplate: boolean = false;
  @Input() hasListHeader: boolean = false;
  @Input() hasError: boolean = false;
  @Input() setPositionDynamically: boolean = true;
  @Input() clickOnSelectedValue: boolean = false;
  @Input() allowDecimal: boolean = false;
  @Input() showImage: boolean = false;
  @Input() isCustomizedTemplate: boolean = false;
  @Input() searchFilter: any = {
    isSearchEnable: false,
    searchPlaceholder: 'Search',
    serachField: 'name',
    maxLength: 1000,
  };
  @Input() listData: any[] = [];
  @Input() showNoDataFound: boolean = false;
  @Input() noDataFoundMessage = 'No data found';

  @Output() appChange = new EventEmitter<string>();
  @Output() appFocus = new EventEmitter<any>();
  @Output() appSelect = new EventEmitter<any>();
  @Output() appCompleteMethod = new EventEmitter<any>();
  @Output() appSave = new EventEmitter<any>();
  @Output() appClickOutside = new EventEmitter<any>();
  @Output() appClickValue = new EventEmitter<any>();
  @Output() appOpenDropdown = new EventEmitter<any>();
  @Output() appCloseDropdown = new EventEmitter<any>();
  @Output() appShiftTab = new EventEmitter<any>();
  @Output() appEditButtonClick = new EventEmitter<any>();

  @ViewChild('autoCompleteInput', { static: true })
  autoCompleteInput: ElementRef;
  @ViewChild('dropdownInput', { static: true }) dropdownInput: ElementRef;
  @ViewChild('createInputField')
  createInputField: ElementRef;
  @ViewChild('createField', { static: true }) createField: ElementRef;
  @ViewChild('openDropdownBtn', { static: true }) openDropdownBtn: ElementRef;
  @ViewChild('dropdownContainer', { static: true })
  dropdownContainer: ElementRef;
  @ViewChild('dropdownList', { static: true }) dropdownList: ElementRef;
  @ViewChild('dropdownListContainer')
  dropdownListContainer: ElementRef;
  @ViewChild('selectedView') selectedView: ElementRef;

  @ContentChildren(AppTemplateDirective) templates: QueryList<any>;

  autocompleteItem: TemplateRef<any>;
  autocompleteItemStatic: TemplateRef<any>;
  autocompleteItemEditable: TemplateRef<any>;
  autocompleteList: TemplateRef<any>;
  dropdownFooter: TemplateRef<any>;
  isDropdownExpanded: boolean = false;
  isSearching: boolean = false;
  isEditable: boolean = false;
  query: string = '';
  selectedColor: string = config.colors[0].value;
  colors: any[] = config.colors;
  isViewInitialized: boolean = false;
  selectedOptionIndex: number = -1;
  subscriptions: Subscription[] = [];
  timeouts: any[] = [];

  constructor(private dataService: DataService, private cdr: ChangeDetectorRef, private helperService: HelperService) {}

  ngOnInit() {}

  ngAfterContentInit() {
    this.getCustomTemplate();
  }

  ngOnChanges(change: any) {
    const { autoFocus } = change;

    if (autoFocus) {
      if (!autoFocus.previousValue && autoFocus.currentValue) {
        this.onFocus();
      }
    }
  }

  ngOnDestroy() {
    this.removeOutsideClickListener();
    // Throwing errors will need to check this later.
    this.removeTimeOutListeners();
  }

  addOutsideClickListener() {
    this.subscriptions.push(
      this.dataService.getClickEvent().subscribe((target) => {
        if (!this.dropdownContainer.nativeElement.contains(target)) {
          this.isDropdownExpanded = false;
          this.isEditable = false;
          this.cdr.detectChanges();
          this.removeOutsideClickListener();
          this.query = '';
          this.appClickOutside.emit();
        }
      })
    );
  }

  removeOutsideClickListener() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  removeTimeOutListeners() {
    this.timeouts.forEach((timeout: any) => {
      clearTimeout(timeout);
    });
  }

  /** change event of the autocomplete */
  onChange(event) {
    this.query = event.target.value;
  }

  onChangeType(event: any) {
    const { value } = event.target;
    if (value === '') {
      this.isShowError = false;
    }
    this.appChange.emit(value);
  }

  /** select color for the created option */
  onColorSelect(value) {
    this.selectedColor = value;
  }

  onFocus() {
    if (!this.isDropdownExpanded) {
      this.onDropdownClick();
    }
  }

  onTabPress() {
    this.isDropdownExpanded = false;
    this.isEditable = false;
    this.removeOutsideClickListener();
    this.appCloseDropdown.emit();
    this.appClickOutside.emit();
  }

  onShiftTabPress() {
    this.appShiftTab.emit();
  }

  onClickOutside() {
    this.isDropdownExpanded = false;
    this.isEditable = false;
    this.removeOutsideClickListener();
    this.query = '';
    this.appClickOutside.emit();
  }

  onValueClick(event) {
    if (this.value && this.clickOnSelectedValue) {
      event.stopPropagation();
      if (this.isDropdownExpanded) {
        this.isDropdownExpanded = false;
        this.isEditable = false;
      }
      this.appClickValue.emit(event);
    }
  }

  /** emit on selection of the item (it will not emit on static and create new item) */
  onSelect(option: any, event) {
    event.stopPropagation();

    if (this.inactiveItemsKey === 'disabled') {
      if (!this.selectInactiveItems && this.inactiveItemsKey && option[this.inactiveItemsKey]) {
        return;
      }
    } else if (!this.selectInactiveItems && this.inactiveItemsKey && !option[this.inactiveItemsKey]) {
      return;
    }

    if (!this.fullyControlled) {
      this.value = option;
    }

    this.appSelect.emit(option);
    if (this.closeOnSelection) {
      this.isDropdownExpanded = false;
      this.isEditable = false;
      this.removeOutsideClickListener();
    }
  }

  /** emit when user click on the save button on the create new section (it will only emit if the query >= 3) */
  onCreate() {
    if (this.createInputField.nativeElement.value && this.editFieldMask) {
      this.query = this.createInputField.nativeElement.value;
    }

    this.appSave.emit({ name: this.query, color: this.selectedColor });

    if (this.hasEditableFieldIndication) {
      this.appSelect.emit({ name: this.query, isFromEditableField: true });
    } else {
      this.appSelect.emit({ name: this.query });
    }

    this.selectedColor = config.colors[0].value;
    this.query = '';
    this.toggleEditMode();
    this.removeOutsideClickListener();
    this.isDropdownExpanded = false;
    this.isEditable = false;
  }

  /** It will toggle the edit mode of the create new input */
  toggleEditMode() {
    if (this.isStaticEditButton) {
      this.appEditButtonClick.emit();
      return;
    }

    this.isEditable = !this.isEditable;
    if (this.isEditable) {
      if (!this.value) {
        this.query = this.autoCompleteInput && this.autoCompleteInput.nativeElement.value;
      } else {
        this.query = '';
      }
    }

    if (this.isEditable) {
      this.timeouts.push(
        setTimeout(() => {
          this.createInputField && this.createInputField.nativeElement.focus();
        }, 10)
      );
    }
  }

  /** emit when user click on the dropdown (it will open the suggestion dropdown if it's not open) */
onDropdownClick(event?: Event) {
  if (event) {
    event.stopPropagation();
  }

  if (this.disabled) {
    return;
  }

  this.isDropdownExpanded = !this.isDropdownExpanded;

  if (this.isDropdownExpanded) {
    this.timeouts.push(
      setTimeout(() => {
        this.dropdownInput.nativeElement.focus();
      }, 10)
    );
    }

    if (this.isDropdownExpanded) {
    this.appOpenDropdown.emit();
    this.addOutsideClickListener();
  } else {
    this.isEditable = false;
    this.appCloseDropdown.emit();
    this.removeOutsideClickListener();
  }

  this.setFocusOnSelectedValue();
    this.setDropdownPosition();
}

  onSelectOption(type: string) {
    if (type === 'up') {
      if (this.selectedOptionIndex === 0) return;

      this.selectedOptionIndex--;
    } else {
      if (this.selectedOptionIndex === this.options.length - 1) {
        this.selectedOptionIndex = 0;
      } else {
        this.selectedOptionIndex++;
      }
    }

    this.setFocusOnHighlightedOption();
  }

  setFocusOnHighlightedOption() {
    this.timeouts.push(
      setTimeout(() => {
        const selectedEl = this.dropdownList.nativeElement.querySelector(`.item${this.selectedOptionIndex}`) as any;

        if (selectedEl) {
          const scrollHeight = parseInt(this.scrollHeight).toString();

          if (selectedEl.offsetTop >= scrollHeight || selectedEl.offsetTop == 1) {
            selectedEl.parentNode.scrollTop = selectedEl.offsetTop - Number(scrollHeight) + selectedEl.offsetHeight;
            this.dropdownList.nativeElement.scrollTop = selectedEl.offsetTop - Number(scrollHeight) + selectedEl.offsetHeight;
          }
        }
      }, 10)
    );
  }

  onEnter(event: Event) {
    if (this.selectedOptionIndex >= 0) {
      const option = this.options[this.selectedOptionIndex];

      if (option) {
        this.onSelect(option, event);
      }
    } else {
      this.removeOutsideClickListener();
      this.isDropdownExpanded = false;
      this.isEditable = false;
    }
  }

  renderValue() {
    const value = this.value && this.value[this.field];

    if (value && this.showSelectedValue) {
      return value;
    } else {
      return false;
    }
  }

  /** It will show the specific field in the dropdown given in the field input */
  resolveFieldData(option) {
    return (option && option[this.field]) || '';
  }

  getCustomTemplate() {
    this.templates.forEach((item) => {
      switch (item.getType()) {
        case 'item':
          this.autocompleteItem = item.template;
          break;

        case 'static':
          this.autocompleteItemStatic = item.template;
          break;

        case 'editable':
          this.autocompleteItemEditable = item.template;
          break;

        case 'list':
          this.autocompleteList = item.template;
          break;

        case 'footer':
          this.dropdownFooter = item.template;
          break;

        case 'open-dropdown-btn':
          this.openDropdownBtn = item.template;
          break;
      }
    });
  }

  setFocusOnSelectedValue() {
    if (this.focusOnSelectedValue) {
      const id = this.value && this.value[this.idKey];

      if (id) {
        this.timeouts.push(
          setTimeout(() => {
            const selectedEl = this.dropdownList.nativeElement.querySelector(`#item-${this.id}${id}`) as HTMLElement;

            if (!!selectedEl) {
              selectedEl.scrollIntoView({ block: 'center', inline: 'nearest' });
              selectedEl.focus();
            }
          }, 10)
        );
      }
    }
  }

setDropdownPosition() {
  if (!this.setPositionDynamically) {
    return;
  }
  
  if(this.isFromTable){
  this.timeouts.forEach(t => clearTimeout(t));
  this.timeouts = [];

  const dropdownEl = this.dropdownListContainer.nativeElement as HTMLElement;
  dropdownEl.style.visibility = 'hidden';
  dropdownEl.style.display = 'block';

  setTimeout(() => {
    const dropdownRect = dropdownEl.getBoundingClientRect();
    const dropdownListHeight = dropdownEl.offsetHeight;
    const selectedViewHeight = this.selectedView.nativeElement.offsetHeight;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;

    const dropdownTop = dropdownRect.top + scrollTop;
    const spaceDown = (scrollTop + windowHeight) - (dropdownTop + dropdownListHeight);
    const spaceUp = dropdownTop - scrollTop - selectedViewHeight;

    const rows = document.querySelectorAll('.purchase-grid-row');
    const totalRows = rows.length;
    const currentRowIndex = Array.from(rows).findIndex(row => row.contains(dropdownEl));    

    if (totalRows - currentRowIndex <= 4 && totalRows > 5) {
      this.position = 'top';
    } else if (spaceDown < dropdownListHeight && spaceUp >= dropdownListHeight) {
      this.position = 'top';
    } else {
      this.position = 'bottom';
    }

    dropdownEl.style.visibility = '';
    dropdownEl.style.display = '';
  }, 0);
}
else{
      this.timeouts.push(
        setTimeout(() => {
          // Calculating Vertical Position of the dropdown
          const dropdownListOffset = this.dropdownListContainer.nativeElement.getBoundingClientRect();
          const dropdownListHeight = this.dropdownListContainer.nativeElement.offsetHeight;
          const selectedViewHeight = this.selectedView.nativeElement.offsetHeight;
          const spaceUp = dropdownListOffset.top - selectedViewHeight - dropdownListHeight - $(window).scrollTop();
          const spaceDown = $(window).scrollTop() + $(window).height() - (dropdownListOffset.top + dropdownListHeight);
          if (spaceDown < 0 && (spaceUp >= 0 || spaceUp > spaceDown)) {
            this.position = 'top';
          } else {
            this.position = 'bottom';
          }
        }, 50)
      );
}
}

  onKeyPress(value) {
    if (this.allowDecimal) {
      let obj: AllowDecimalMask = {
        event: value,
        ngModelValue: this.query,
        inputControl: this.createInputField,
        isChanged: false,
      };
      let isAllowChange: boolean = this.helperService.onKeyPress(obj);
      if (obj.isChanged) {
        this.query = obj.ngModelValue;
      }
      return isAllowChange;
    }
  }

  validatePaste(event) {
    if (this.allowDecimal) {
      let obj: AllowDecimalMask = {
        event: event,
        ngModelValue: this.query,
        inputControl: this.createInputField,
        isChanged: false,
      };
      let isAllowChange: boolean = this.helperService.validatePaste(obj);
      if (obj.isChanged) {
        this.query = obj.ngModelValue;
      }

      return isAllowChange;
    }
  }

  onSearch(e: any, searchFilter: string) {
    this.query = e.toLowerCase();
    if (!this.query) {
      this.options = this.helperService.deepCopy(this.listData);
    }
    this.options = this.listData.filter((data) => {
      if (data[searchFilter]) {
        return ('' + data[searchFilter]).toLowerCase().includes(this.query);
      } else {
        return data;
      }
    });
  }
}
